import { isPreciseLocation } from './is-precise-location.util';

import { Place } from '@/types/google-maps.types';

const countrySuffixRegex = /,\s*(?:brasil|brazil)\s*$/i;
const zipcodeSuffixRegex = /,\s*\d{5}-?\d{3}\s*$/;

const toCityAndState = (place: Place): string =>
  (place.city && place.state ? `${place.city} - ${place.state}` : place.formattedAddress);

const toStreetAddress = (place: Place): string =>
  place.formattedAddress
    .replace(countrySuffixRegex, '')
    .replace(zipcodeSuffixRegex, '')
    .trim();

export const formatLocationLabel = (place?: Place): string => {
  if (!place) {
    return '';
  }

  if (!isPreciseLocation(place)) {
    return toCityAndState(place);
  }

  return toStreetAddress(place) || toCityAndState(place);
};
